diffPredicate